/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SettingsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABlElEQVR4nM1VS07DQAyNxBrK5wA9Ap9TVG3Gdlo54wYhVuVAfHoeYAusKFLXBe7QTQE5TVA7zYT0I2Akb8Yev7GfP0HwHw4zbwHZAZCMVQzJi95tDADxfBdIPmeFmWsrOWu2k7ohuTdkL/K7MIpPXADE5CjXq60hudO3FZzb98zJB6D0IYoFUJ5cAEP2MdP1U9vp/VspiP7CdQTLCtpbLwCQ9GZ+s7QYtBP1UZomIHuzegT2MvjpIFq7mG8ZhdjtAMC2SohdMiTDAru40KnWdKuV7AHIsUuoIRkx8777Ru1V5xKvFae6uT7RxvGFHWK3401nZLkkXYNZcsdeQ4BtH0CjcbpTwsl4bQBmrlUESOeML0XkA1BS/f0gz4Ukpx06T/JQda5zorMDg/bVIfmhFcWHCyTPExdLUZlCZFlzrqI/d52XlummGs2gvS51rlNxnVEB07e9vxt2zXZS15GbhTsBlCvNvUt83rVpo6lN1XGdg2SRfIcKOkJKFo7aVlo4v7Iyg4KjNZ3Nq3TpaxNtdOmvc74AyjcwuxaurGsAAAAASUVORK5CYII=)
 */
export const SettingsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M10.56 1.1c-.46.05-.7.53-.64.98.18 1.16-.19 2.2-.98 2.53-.8.33-1.79-.15-2.49-1.1-.27-.36-.78-.52-1.14-.24-.77.59-1.45 1.27-2.04 2.04-.28.36-.12.87.24 1.14.96.7 1.43 1.7 1.1 2.49-.33.8-1.37 1.16-2.53.98-.45-.07-.93.18-.99.64a11.1 11.1 0 0 0 0 2.88c.06.46.54.7.99.64 1.16-.18 2.2.19 2.53.98.33.8-.14 1.79-1.1 2.49-.36.27-.52.78-.24 1.14.59.77 1.27 1.45 2.04 2.04.36.28.87.12 1.14-.24.7-.95 1.7-1.43 2.49-1.1.8.33 1.16 1.37.98 2.53-.07.45.18.93.64.99a11.1 11.1 0 0 0 2.88 0c.46-.06.7-.54.64-.99-.18-1.16.19-2.2.98-2.53.8-.33 1.79.14 2.49 1.1.27.36.78.52 1.14.24.77-.59 1.45-1.27 2.04-2.04.28-.36.12-.87-.24-1.14-.96-.7-1.43-1.7-1.1-2.49.33-.8 1.37-1.16 2.53-.98.45.07.93-.18.99-.64a11.1 11.1 0 0 0 0-2.88c-.06-.46-.54-.7-.99-.64-1.16.18-2.2-.19-2.53-.98-.33-.8.14-1.79 1.1-2.49.36-.27.52-.78.24-1.14a11.07 11.07 0 0 0-2.04-2.04c-.36-.28-.87-.12-1.14.24-.7.96-1.7 1.43-2.49 1.1-.8-.33-1.16-1.37-.98-2.53.07-.45-.18-.93-.64-.99a11.1 11.1 0 0 0-2.88 0ZM16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
